<template>
  <div class="text-center padding">
    <h2
      class="mt-0 text-left slide-title-style"
      v-html="dataValue"
      v-if="slide.title && slide.type != 'document'"
    />
    <div
      class="audio-control-slide"
      v-if="slide.audioLink && slide.audioPlayOnAudience && slide.id"
    >
      <AudioControl />
    </div>
    <div class="img-slide" v-if="slide.image">
      <img :src="slide.image.large" alt="">
    </div>
    <div
      class="img-caption text-break"
      v-if="slide.subheading && slide.type != 'document'"
      :inner-html.prop="slide.subheading | sanitize(true)"
    />
    <div class="no-data" v-if="!slide.subheading && !slide.image">
      <p class="custom-mb-3">
        {{ $t("blankSlide") }}
      </p>
    </div>
  </div>
</template>
<script>
import AudioControl from '@/components/AudioControl.vue'
import { mapGetters } from 'vuex'
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'

export default {
  components: {
    AudioControl,
  },
  mixins: [ClickableTitleMixin],
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
.img-slide {
  img {
    max-width: 100%;
    max-height: 400px;
  }
}
.img-caption {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.audio-control-slide {
  text-align: center !important;
}
</style>
